var map = {
	"./strength-1.png": "d055",
	"./strength-2.png": "0b4b",
	"./strength-3.png": "2bdf",
	"./strength-4.png": "28ad",
	"./strength-5.png": "97c6",
	"./strength-6.png": "f480"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec5b";